import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'

import { Button, TextField } from '@mui/material';
import { ToastContainer } from 'react-toastify';

import './Login.css';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../../modules/header/header';
import { AuthService } from '../../services/AuthService';
import BasicCard from '../../components/card/Card';

import image4 from '../../assets/logo2.jpg';
import { mostraMensagemErro, mostraMensagemSucesso } from '../../helpers/Notificacoes';

function Login() {

  const authService = new AuthService();

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  async function validateLogin() {
    const REACT_APP_ADM_MOBILE = process.env.REACT_APP_ADM_MOBILE;
    const REACT_APP_ADM_SUP = process.env.REACT_APP_ADM_SUP;

    const login = await authService.login(
      {
        email: user,
        password
      },
      "/v1/auth"
    ).then((response) => {
      console.log("response:", response); // Deve aparecer no console do navegador
      return response;
    })
      .catch((error) => {
        return error;
      });


    if (login.codigo !== 200) {
      mostraMensagemErro(login.mensagem || "Erro ao realizar o login, tente novamente");
      setUser('');
      setPassword('');

    } else {
      //await mostraMensagemSucesso('Login efetuado com sucesso');

        await localStorage.setItem('stbs', "true");
        await localStorage.setItem('udbs', JSON.stringify(login.status.dadosLogin));

      if (login.status.dadosLogin.email === REACT_APP_ADM_SUP) {
        navigate("/mvp", {
          state: {
            propsPage: "homeAdm"
          }
        })
      } else {      

        if (login.status.dadosLogin.email === REACT_APP_ADM_MOBILE) {
          navigate("/mvp", {
            state: {
              propsPage: "empresas"
            }
          })
        } else {
          navigate("/mvp")
        }
      }
    }
  }

  return (
    <div className="Login">
      <div className="LoginBottom">
        <BasicCard>
          <div className="logo-container">
            <img
              src={image4}
              alt="Logo"
              style={{ width: 200, height: 80 }}
            />
          </div>
          <TextField
            className="fields"
            required
            id="filled-required"
            label="E-mail"
            variant="outlined"
            value={user}
            onChange={(e) => setUser(e.target.value.toLowerCase())}
            sx={{ marginBottom: 2 }}
            autoFocus
          />
          <TextField
            className="fields"
            required
            id="filled-password-input"
            label="Senha"
            type="password"
            autoComplete="current-password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ marginBottom: 3 }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                validateLogin();
              }
            }}
          />
          <Button
            variant="contained"
            onClick={validateLogin}
            sx={{
              width: { xs: '100%', sm: '50%', md: '40%' },
              maxWidth: 200,
              backgroundColor: '#5693B9'
            }}
          >
            Login
          </Button>
          <ToastContainer />
          <div style={{ marginTop: '16px', textAlign: 'center' }}>
            <a href="/esqueci-minha-senha" style={{ textDecoration: 'none', color: '#5693B9' }}>
              Esqueci minha senha
            </a>
          </div>
        </BasicCard>
      </div>
    </div>
  );
}

export default Login;
